import { FC } from 'react';
import { FormControlLabelProps, Radio as MuiRadio } from '@mui/material';

import { FormControlLabelStyled } from './styled';

type TFormControlLabelForwardProps = Pick<
	FormControlLabelProps,
	| 'checked'
	| 'onChange'
	| 'label'
	| 'name'
	| 'value'
	| 'disabled'
	| 'labelPlacement'
	| 'sx'
	| 'className'
>;

export interface IRadioProps extends TFormControlLabelForwardProps {
	testId?: string;
	labelTestId?: string;
}

export const Radio: FC<IRadioProps> = ({
	testId,
	labelTestId,
	...formControlLabelProps
}) => {
	return (
		<FormControlLabelStyled
			control={<MuiRadio color="primary" data-testid={testId} />}
			data-testid={labelTestId}
			{...formControlLabelProps}
		/>
	);
};
